import { ModelDef } from '../../CORE/src/common/$models/ModelDef'
import { ModelFixedHolidays } from './yhcDataTypes'

/**
 * 固定休日マスタ
 * - 年末年始休業など、毎年同じ期間の休日を管理する
 */
export const fixed_holidays: ModelDef<ModelFixedHolidays> = {
  tableName: 'fixed_holidays',
  tableLabel: '固定休日マスタ',
  tableComment: '年末年始休業を管理する',
  primaryKeyColType: 'NUMBER',
  columns: {
    name: {
      type: 'STRING',
      label: '休日名称',
      adminComment: '休日の名前を入力します。（例: 年末年始休業）',
      validate: { notEmpty: true },
    },
    start_month_day: {
      type: 'STRING',
      label: '開始日 (MM-DD)',
      adminComment: '「MM-DD」形式で入力してください。例: 12-30',
      inputHelpText: '「MM-DD」形式で入力してください。例: 12-30',
      validate: { notEmpty: true },
    },
    end_month_day: {
      type: 'STRING',
      label: '終了日 (MM-DD)',
      adminComment:
        '「MM-DD」形式で入力してください。年をまたぐ場合は開始日より前の日付になります。例: 01-03',
      inputHelpText:
        '「MM-DD」形式で入力してください。年をまたぐ場合は開始日より前の日付になります。例: 01-03',
      validate: { notEmpty: true },
    },
    description: {
      type: 'TEXT',
      label: '説明',
      adminComment: 'この休日に関する補足事項があれば入力してください。',
    },
  },
}
